import { Translate } from "@redotech/redo-i18n";
import {
  getViewNameValidationErrorCode,
  ViewNameValidationErrorCode,
  ViewNameValidationOptions,
} from "@redotech/redo-views-common/views";

export function getLocalizedViewNameValidationError(
  t: Translate,
  name: string,
  options?: ViewNameValidationOptions,
): string | undefined {
  switch (getViewNameValidationErrorCode(name, options)) {
    case undefined:
      return undefined;
    case ViewNameValidationErrorCode.EMPTY:
      return t("Name cannot be empty");
    case ViewNameValidationErrorCode.DOTS_ONLY:
      return t("Name cannot consist only of dots");
    case ViewNameValidationErrorCode.CONTROL_CHARACTERS:
      return t("Name cannot contain control characters");
    case ViewNameValidationErrorCode.RESERVED:
      return t("Name cannot be a reserved system view name");
  }
}
